import { useState } from 'react';

const useCustomModal = () => {
  const [isModal, setIsModal] = useState({
    open: false,
    message: '',
    message2: '',
  });

  const toggleModal = () => {
    setIsModal((prevIsModal) => ({
      ...prevIsModal,
      open: !isModal.open,
      message: '',
      message2: '',
    }));
  };

  const handleToggleModal = (message, message2) => {
    setIsModal((prevIsModal) => ({
      ...prevIsModal,
      open: !prevIsModal.open,
      message,
      message2,
    }));
  };

  return { isModal, toggleModal, handleToggleModal };
};

export default useCustomModal;
